import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type StartRampConnectMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type StartRampConnectMutation = { __typename?: 'Mutation', startRampConnect: { __typename?: 'StartRampConnectPayload', authorizeUrl?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteRampConnectMutationVariables = Types.Exact<{
  input: Types.CompleteRampConnectInput;
}>;


export type CompleteRampConnectMutation = { __typename?: 'Mutation', completeRampConnect: { __typename?: 'RampConnectionPayload', rampConnection?: { __typename?: 'RampConnectionData', status: Types.RampConnectionStatus, entityId?: string | null, entityName?: string | null, needsEntitySelection: boolean, copyPurchaseOrders: boolean, connectedAt?: Types.TDateISO | null, connectedBy?: string | null, entities: Array<{ __typename?: 'RampEntityData', id: string, name: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SelectRampEntityMutationVariables = Types.Exact<{
  input: Types.SelectRampEntityInput;
}>;


export type SelectRampEntityMutation = { __typename?: 'Mutation', selectRampEntity: { __typename?: 'RampConnectionPayload', rampConnection?: { __typename?: 'RampConnectionData', status: Types.RampConnectionStatus, entityId?: string | null, entityName?: string | null, needsEntitySelection: boolean, copyPurchaseOrders: boolean, connectedAt?: Types.TDateISO | null, connectedBy?: string | null, entities: Array<{ __typename?: 'RampEntityData', id: string, name: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetRampCopyPurchaseOrdersMutationVariables = Types.Exact<{
  input: Types.SetRampCopyPurchaseOrdersInput;
}>;


export type SetRampCopyPurchaseOrdersMutation = { __typename?: 'Mutation', setRampCopyPurchaseOrders: { __typename?: 'RampConnectionPayload', rampConnection?: { __typename?: 'RampConnectionData', status: Types.RampConnectionStatus, entityId?: string | null, entityName?: string | null, needsEntitySelection: boolean, copyPurchaseOrders: boolean, connectedAt?: Types.TDateISO | null, connectedBy?: string | null, entities: Array<{ __typename?: 'RampEntityData', id: string, name: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DisconnectRampMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DisconnectRampMutation = { __typename?: 'Mutation', disconnectRamp: { __typename?: 'RampConnectionPayload', rampConnection?: { __typename?: 'RampConnectionData', status: Types.RampConnectionStatus, entityId?: string | null, entityName?: string | null, needsEntitySelection: boolean, copyPurchaseOrders: boolean, connectedAt?: Types.TDateISO | null, connectedBy?: string | null, entities: Array<{ __typename?: 'RampEntityData', id: string, name: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const StartRampConnectDocument = new TypedDocumentString(`
    mutation StartRampConnect {
  startRampConnect {
    authorizeUrl
    errors {
      code
      message
    }
  }
}
    `);
export const CompleteRampConnectDocument = new TypedDocumentString(`
    mutation CompleteRampConnect($input: CompleteRampConnectInput!) {
  completeRampConnect(input: $input) {
    rampConnection {
      ...RampConnectionFields
    }
    errors {
      code
      message
    }
  }
}
    fragment RampConnectionFields on RampConnectionData {
  status
  entityId
  entityName
  entities {
    id
    name
  }
  needsEntitySelection
  copyPurchaseOrders
  connectedAt
  connectedBy
}`);
export const SelectRampEntityDocument = new TypedDocumentString(`
    mutation SelectRampEntity($input: SelectRampEntityInput!) {
  selectRampEntity(input: $input) {
    rampConnection {
      ...RampConnectionFields
    }
    errors {
      code
      message
    }
  }
}
    fragment RampConnectionFields on RampConnectionData {
  status
  entityId
  entityName
  entities {
    id
    name
  }
  needsEntitySelection
  copyPurchaseOrders
  connectedAt
  connectedBy
}`);
export const SetRampCopyPurchaseOrdersDocument = new TypedDocumentString(`
    mutation SetRampCopyPurchaseOrders($input: SetRampCopyPurchaseOrdersInput!) {
  setRampCopyPurchaseOrders(input: $input) {
    rampConnection {
      ...RampConnectionFields
    }
    errors {
      code
      message
    }
  }
}
    fragment RampConnectionFields on RampConnectionData {
  status
  entityId
  entityName
  entities {
    id
    name
  }
  needsEntitySelection
  copyPurchaseOrders
  connectedAt
  connectedBy
}`);
export const DisconnectRampDocument = new TypedDocumentString(`
    mutation DisconnectRamp {
  disconnectRamp {
    rampConnection {
      ...RampConnectionFields
    }
    errors {
      code
      message
    }
  }
}
    fragment RampConnectionFields on RampConnectionData {
  status
  entityId
  entityName
  entities {
    id
    name
  }
  needsEntitySelection
  copyPurchaseOrders
  connectedAt
  connectedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    StartRampConnect: build.mutation<StartRampConnectMutation, StartRampConnectMutationVariables | void>({
      query: (variables) => ({ document: StartRampConnectDocument, variables })
    }),
    CompleteRampConnect: build.mutation<CompleteRampConnectMutation, CompleteRampConnectMutationVariables>({
      query: (variables) => ({ document: CompleteRampConnectDocument, variables })
    }),
    SelectRampEntity: build.mutation<SelectRampEntityMutation, SelectRampEntityMutationVariables>({
      query: (variables) => ({ document: SelectRampEntityDocument, variables })
    }),
    SetRampCopyPurchaseOrders: build.mutation<SetRampCopyPurchaseOrdersMutation, SetRampCopyPurchaseOrdersMutationVariables>({
      query: (variables) => ({ document: SetRampCopyPurchaseOrdersDocument, variables })
    }),
    DisconnectRamp: build.mutation<DisconnectRampMutation, DisconnectRampMutationVariables | void>({
      query: (variables) => ({ document: DisconnectRampDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useStartRampConnectMutation, useCompleteRampConnectMutation, useSelectRampEntityMutation, useSetRampCopyPurchaseOrdersMutation, useDisconnectRampMutation } = injectedRtkApi;
